import React from 'react';
//import { NavItem, Nav, NavDropdown, MenuItem } from 'react-bootstrap'
import NavItem from 'react-bootstrap/lib/NavItem'
import Nav from 'react-bootstrap/lib/Nav'
import NavDropdown from 'react-bootstrap/lib/NavDropdown'
import MenuItem from 'react-bootstrap/lib/MenuItem'
import { myRoutes } from '../../routes/app.jsx'
import { /*HostUrl, */ LocalDir, DevBuild, DemoBuild } from '../../variables/Config'

class HeaderLinks extends React.PureComponent{
    render(){
        const demoAlarm = ['אלברגה', 'לופז', 'ברנן', 'אוחנה']
        const { hostUrl } = this.props
        const notification = (
            <div>
                <i className="fa fa-globe"></i>
                <b className="caret"></b>
                <span className="notification">{demoAlarm.length}</span>
                <p className="hidden-lg hidden-md">הודעות</p>
            </div>
        )
        var keyLink = 1000
        //console.log("role=", this.props.userRole )
        return (
            <div>
                <Nav>
                    <NavItem eventKey={1} href="#">
                        <i className="fa fa-dashboard"></i>
                        <p className="hidden-lg hidden-md">לוח בקרה</p>
                    </NavItem>
                    {(DemoBuild || DevBuild) &&
                        <NavDropdown eventKey={2} title={notification} noCaret id="basic-nav-dropdown">
                         {demoAlarm.map((item, index) => 
                            <MenuItem key={index} eventKey={'2.'+index}>{'נתוני משפחת '+item}</MenuItem>)
                            }  
                        </NavDropdown>
                    }
                    {/*<NavItem eventKey={3} href="#">
                        <i className="fa fa-search"></i>
                        <p className="hidden-lg hidden-md">חיפוש</p>
        </NavItem>*/}
                </Nav>
                <Nav pullRight>
                    { !DevBuild ? null :
                        <NavDropdown eventKey={4} title="טפסים" id="basic-nav-dropdown-left">
                            { myRoutes.map((prop,key) => {
                                // console.log(keyLink)
                                if (prop.divider)
                                    return ( <MenuItem key={key} divider /> )
                                if (!prop.redirect)
                                    return (
                                        <MenuItem key={key} eventKey={++keyLink} href={prop.path}>{prop.name}</MenuItem>
                                    )
                                return null
                            })}
                        </NavDropdown>
                    }
                    
                    { !DevBuild ? null : 
                        <NavDropdown eventKey={5} title="טבלאות" id="basic-nav-dropdown-left">
                            <MenuItem eventKey={5.1} href={LocalDir + "/#/user"}>נתוני משתמש</MenuItem>
                            <MenuItem eventKey={5.2} href={LocalDir + "/#/Editdata"}>טבלה לעריכה</MenuItem>
                            {/*<MenuItem eventKey={5.3} href={LocalDir + "/#/RestApi"}>RestApi</MenuItem>*/}
                            {/*<MenuItem eventKey={5.4} href={LocalDir + "/#/FamilyReferralForm"}>הפניה חדשה</MenuItem>*/}
                            {/*<MenuItem eventKey={5.5} href={LocalDir + "/#/FamilyIntakeForm"}>אינטייק חדש</MenuItem>
                            <MenuItem eventKey={5.6} href={LocalDir + "/#/MeetingSummaryTable"}>סיכומי מפגש</MenuItem>*/}
                            <MenuItem eventKey={5.7} href={LocalDir + "/#/Notification"}>התראות</MenuItem>
                            <MenuItem divider />
                            <MenuItem eventKey={5.8} href="https://www.fullstackreact.com/articles/how-to-write-a-google-maps-react-component/">Google Map Component</MenuItem>
                            <MenuItem eventKey={5.9} href="https://www.fullstackreact.com/">React FullStack Book</MenuItem>
                            <MenuItem eventKey={5.10} href="http://themes-pixeden.com/font-demos/7-stroke/index.html">אייקונים</MenuItem>
                            <MenuItem eventKey={5.11} href="https://www.npmjs.com/package/survey-react">שאלונים</MenuItem>
                        </NavDropdown>
                    }
                    { this.props.userRole !== 'administrator' ? null : 
                        <NavDropdown eventKey={6} title='דו"חות' id="basic-nav-dropdown-left">
                            <MenuItem eventKey={6.1} target="_blank" href={hostUrl + "/report-referrals/"}>הפניות (16)</MenuItem>
                            <MenuItem eventKey={6.2} target="_blank" href={hostUrl + "/report-intakes/"}>אינטייק (6)</MenuItem>
                            <MenuItem eventKey={6.3} target="_blank" href={hostUrl + "/report-program/"}>משפחות (13)</MenuItem>
                            <MenuItem eventKey={6.4} target="_blank" href={hostUrl + "/report-parents/"}>הורים (13)</MenuItem>
                            <MenuItem eventKey={6.5} target="_blank" href={hostUrl + "/report-sroi/"}>מסכם</MenuItem>
                            <MenuItem eventKey={6.6} target="_blank" href={hostUrl + "/report-bros/"}>משפחות עד תמונת מצב התחלה</MenuItem>
                            <MenuItem eventKey={6.7} target="_blank" href={hostUrl + "/report-bros2/"}>SROI חלק ראשון</MenuItem>
                            <MenuItem eventKey={6.8} target="_blank" href={hostUrl + "/report-bros3/"}>SROI חלק שני</MenuItem>
                        </NavDropdown>
                    }

                    <NavItem onClick={() => window.open(hostUrl+'/yahav-manual', '_blank')} eventKey={7}>הוראות הפעלה</NavItem>
                    <NavItem eventKey={8} href="/#/user">חשבון</NavItem>
                    <NavItem eventKey={9} href={/*hostUrl +*/ "/"}>יציאה</NavItem>
                </Nav>
            </div>
        )
    }
}

export default HeaderLinks;
